module.exports = __webpack_public_path__ + "img/bigTruck-blue.bbeea667.svg";